const myArticles = [
	() => ({
		date: "May 2023 - May 2024",
		title: "Integration of Autoware with vehicle's on-board computer",
		description:
			'Installed Autoware Autonomy Stack, required sensor drivers, and the vehicle-specific modified packages on the onboard vehicle computer.\n Created the Vehicle Description and Sensor Kit ROS2 packages, for integrating camera, lidar, GNNS, and other sensors onto its platform. \nMigrated vehicle’s stock Dataspeed perception stack into Autoware for seamless integration. ',
		keywords: [
			"Orthogonality",
			"Disentanglement",
			"Generative Models",
			"Data Manifold",
			"Latent Space",
			"Chart-Autoencoder",
			"Image Generation",
			"Representation Learning",
			"3D Shapes Dataset",
			"Hyperparameter Tuning",
			"Image Manipulation"],

		link: "/research",
		
		link_text: "Link",
	}),
	() => ({
		date: "January 2023 - May 2024",
		title: "Intelligent Parking Solutions for Autonomous Vehicles",
		description:
			'Developed and designed an parking space detection sytem for Autonomous Vehicles in collaboration with Cox and ASU.\n Incorporated multiple cameras in the parking lot and fine tuned YOLO for generalizing parking space extraction and classification while reducing perspective distortions and achieving an accuracy of 95% against occlusions.\n Deployed the system using NVIDIA Jetson AGX Orion for handling simultanious video streams from cameras, enabling low-latency',
		keywords: [
			"Autonomous Driving",
			"YOLO",
			"Parking Space Detectionn",
			"NVIDIA Jetson Orion AGX"
			],

		link: "https://youtu.be/PPt7d1hTMuw?si=n_OVVVxZHd1NKlD0",
		
		link_text: "Link",
	}),



	// Add more articles here if needed
];

export default myArticles;
